export default __webpack_public_path__ + "static/media/xsol.ebce64eb.png";